var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentUrl == '/not-found' || _vm.currentUrl == '/coming-soon')?_c('div'):_c('HeaderGreenCard'),_c('div',[_c('ProfessionPilot')],1),(_vm.currentUrl == '/not-found' || _vm.currentUrl == '/coming-soon')?_c('div'):_c('FooterGreenCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }